import {
  Stack,
  Breadcrumbs,
  Link,
  Typography,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Tooltip,
  IconButton,
  Box,
  Chip,
  TextField,
  Grid,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import { MdCheckCircleOutline, MdComputer } from "react-icons/md"; // React icon for desktop
import { MdSmartphone } from "react-icons/md"; // React icon for mobile
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import DescriptionImg from "./img/descriptionImg2002.png";
import { MdPhoneIphone } from "react-icons/md";
import { FcPhoneAndroid } from "react-icons/fc";
import CodeBlock from "./CodeBlock";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import { MdOutlineContentCopy } from "react-icons/md";
import { VscJson } from "react-icons/vsc";
import { DiAndroid } from "react-icons/di";
import { FaApple } from "react-icons/fa6";
import { HiDotsHorizontal } from "react-icons/hi";
import AndroidImg from "./img/AndroidImg2002.png";
import IosImg from "./img/IosImg2002.png";
import FirstTable from "./FirstTable";
import SecondTable from "./SecondTable";
import CurlHeaderTable from "./CurlHeaderTable";
import shareIcon from "./TemplateData/share.png";
import facebookImg from "./TemplateData/facebook.png";
import linkedinImg from "./TemplateData/linkedin.png";
import twitterImg from "./TemplateData/twitter.png";
import linkImg from "./TemplateData/link.png";
import AndroidIcon from "./img/android.png";
import appleIcon from "./img/apple.png";
import WhatsAppComponentTable2 from "./WhatsAppComponentTable2";
import { useNavigate } from "react-router-dom";
import { BsReply } from "react-icons/bs";
import { IoCallOutline } from "react-icons/io5";

const Template8 = ({ card }) => {
  const [cards, setCards] = useState([]); // State to store templates fetched from API
  const [currentIndex, setCurrentIndex] = useState(0); // for previous & next
  const [currentCard, setCurrentCard] = useState(null); // for selected card
  const [loading, setLoading] = useState(true); // State for loading status
  const [imageStatus, setImageStatus] = useState(true); // State true set for Android, false for ios
  const [selected, setSelected] = useState("desktop");
  const [cardImg, setCardImg] = useState("");
  const [copied, setCopied] = useState(false);

  const navigate = useNavigate();

  const [showShareOptions, setShowShareOptions] = useState(false);

  const [selectedArrow, setSelectedArrow] = useState("prev");

  const [platform, setPlatform] = useState("android");
  const [direction, setDirection] = useState(""); // no animation on load
  const [hasAnimatedOnce, setHasAnimatedOnce] = useState(false);

  const handleImageStatus = () => {
    setImageStatus(true); // Toggle the state android
  };

  const handleImageStatus1 = () => {
    setImageStatus(false); // Toggle the state ios
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(codeString);
    setCopied(true);

    // Reset to original state after 3 seconds
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const handleCopy2 = () => {
    navigator.clipboard.writeText(codeString2);
    setCopied(true);

    // Reset to original state after 3 seconds
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const handleCopy3 = () => {
    navigator.clipboard.writeText(codeString3);
    setCopied(true);

    // Reset to original state after 3 seconds
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const handleCopy4 = () => {
    navigator.clipboard.writeText(codeString4);
    setCopied(true);

    // Reset to original state after 3 seconds
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  const codeString = `
curl 'https://<BASE_URL>/<API_VERSION>/<WHATSAPP_BUSINESS_PHONE_NUMBER_ID>/messages' \\
-H 'Content-Type: application/json' \\
-H 'Authorization: Bearer +ahsg8ybds84jkkjsdbj58' \\
-d '{
  "messaging_product": "whatsapp",
  "recipient_type": "individual",
  "to": "7754542410",
  "type": "interactive",
  "interactive": {
    "type": "cta_url",
    "header": {
      "type": "text",
      "text": "Summer Fashion Sale - Up to 50% off on all apparel!"
    },
    "body": {
      "text": "☀ Get ready for the hottest summer styles at the coolest prices!\\nExplore our Summer Collection and enjoy 50% off on all trendy apparel.\\n 👚 Limited Stock, Hurry!"
    },
    "footer": {
      "text": "🚚 Free shipping on orders above ₹999!"
    },
    "action": {
      "buttons": [
      {
        "type": "url",
        "url_button": {
          "text": "Shop now",
          "url": "https://yourshop.com"
        }
      },
      {
        "type": "url",
        "url_button": {
          "text": "View Deals",
          "url": "https://yourshop.com/view-details"
        }
      }
    ]
    }
  }
}'`;

  const codeString2 = `
curl 'https://<BASE_URL>/v22.0/106540352242922/messages' \\
-H 'Content-Type: application/json' \\
-H 'Authorization: Bearer EAAJB...' \\
-d '{
  "messaging_product": "whatsapp",
  "recipient_type": "individual",
  "to": "+16505551234",
  "type": "interactive",
  "interactive": {
    "type": "button",
    "header": {
      "type": "image",
      "image": {
        "id": "2762702990552401"
      }
    },
    "body": {
      "text": "Hi Pablo! Your gardening workshop is scheduled for 9am tomorrow. Use the buttons if you need to reschedule. Thank you!"
    },
    "footer": {
      "text": "Lucky Shrub: Your gateway to succulents!™"
    },
    "action": {
      "buttons": [
        {
          "type": "reply",
          "reply": {
            "id": "change-button",
            "title": "Change"
          }
        },
        {
          "type": "reply",
          "reply": {
            "id": "cancel-button",
            "title": "Cancel"
          }
        }
      ]
    }
  }
}'`;

  const codeString3 = `
curl 'https://<BASE_URL>/<API_VERSION>/<WHATSAPP_BUSINESS_PHONE_NUMBER_ID>/messages/status' \\
-H 'Content-Type: application/json' \\
-H 'Authorization: Bearer <ACCESS_TOKEN>' \\
-d '{
  "messaging_product": "whatsapp",
  "contacts": [
    {
      "input": "+16505551234",
      "wa_id": "16505551234"
    }
  ],
  "messages": [
    {
      "id": "wamid.HBgLMTY0NjcwNDM1OTUVAgARGBI1RjQyNUE3NEYxMzAzMzQ5MkEA"
    }
  ]
}'`;

  const codeString4 = `
curl 'https://<BASE_URL>/<API_VERSION>/<WHATSAPP_BUSINESS_ACCOUNT_ID>/webhook' \\
-H 'Content-Type: application/json' \\
-H 'Authorization: Bearer <ACCESS_TOKEN>' \\
-d '{
  "object": "whatsapp_business_account",
  "entry": [
    {
      "id": "102290129340398",
      "changes": [
        {
          "value": {
            "messaging_product": "whatsapp",
            "metadata": {
              "display_phone_number": "15550783881",
              "phone_number_id": "106540352242922"
            },
            "contacts": [
              {
                "profile": {
                  "name": "Pablo Morales"
                },
                "wa_id": "16505551234"
              }
            ],
            "messages": [
              {
                "context": {
                  "from": "15550783881",
                  "id": "wamid.HBgLMTY0NjcwNDM1OTUVAgARGBJBM0Y4RUU0RUNFQkFDMjYzQUMA"
                },
                "from": "16505551234",
                "id": "wamid.HBgLMTY0NjcwNDM1OTUVAgASGBQzQThBREYwNzc2RDc2QjA1QTIwMgA=",
                "timestamp": "1714510003",
                "type": "interactive",
                "interactive": {
                  "type": "button_reply",
                  "button_reply": {
                    "id": "change-button",
                    "title": "Change"
                  }
                }
              }
            ]
          },
          "field": "messages"
        }
      ]
    }
  ]
}'`;

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
        const response = await fetch("http://localhost:5000/api/all_templates");
        if (response.ok) {
          const data = await response.json();
          setCards(data);
          setCurrentCard(data[0]); // By default first card show
        } else {
          console.error("Failed to fetch templates");
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, []);

  // After fetching cards and card prop available
  useEffect(() => {
    if (cards.length > 0 && card) {
      const index = cards.findIndex((item) => item.temp_id === card.temp_id);
      if (index !== -1) {
        setCurrentIndex(index);
        setCurrentCard(cards[index]);
      }
    }
  }, [cards, card]);

  const handleToggle = (view) => {
    setSelected(view);
  };
  // console.log("Template_selected_card:==========>>>", card);
  // console.log("Template_all_card:==========>>>", cards);

  // Handle left button click
  const handlePrev = () => {
    const newIndex = (currentIndex - 1 + cards.length) % cards.length;
    setCurrentIndex(newIndex);
    setCurrentCard(cards[newIndex]);
  };

  // Handle right button click
  const handleNext = () => {
    const newIndex = (currentIndex + 1) % cards.length;
    setCurrentIndex(newIndex);
    setCurrentCard(cards[newIndex]);
  };

  return (
    <Stack
      sx={{
        // border: "1px solid blue",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: { xl: "column", lg: "row", sm: "row", xs: "row" },
      }}
    >
      <Stack
        sx={{
          height: "auto",
          // border: "2px solid green",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "40px",
        }}
      >
        <Stack
          sx={{
            // border: "1px solid red",
            display: "flex",
            flexDirection: {
              xl: "column",
              lg: "column",
              sm: "column",
              xs: "column",
            },
            width: { xl: "70%", lg: "90%", sm: "100%", xs: "100%" },
            justifyContent: "space-between",
            height: "auto",
          }}
        >
          <Stack
            direction="row"
            sx={{
              // border: "1px solid red",
              width: "100%",
              alignItems: "flex-start", // Important for sticky to behave as expected
              gap: 8,
              height: "auto",
            }}
          >
            <Box
              sx={{
                // border: "1px solid red",
                width: "66%",
                height: "auto",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Stack
                sx={{
                  // border: "1px solid red",
                  display: "flex",
                }}
              >
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator="›"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "#0066cc", // Text color
                    // border: "2px solid red",
                    // marginLeft: "16px",
                  }}
                >
                  <Link
                    underline="hover"
                    // color="rgb(5 78 146)"
                    href="/"
                    sx={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Home
                  </Link>
                  <Link
                    underline="hover"
                    // color="rgb(5 78 146)"
                    href="/"
                    sx={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Email-templates
                  </Link>
                  <Typography
                    color="text.primary"
                    sx={{ fontSize: "16px", fontWeight: "bold" }}
                  >
                    {/* {card?.title} */}
                    marketing
                  </Typography>
                </Breadcrumbs>
              </Stack>

              {/* Template details */}
              <Box
                sx={{
                  width: "100%",
                  marginTop: "20px",
                  // border: "1px solid red",
                }}
              >
                <Stack
                  direction={{
                    xl: "row",
                    lg: "row",
                    md: "row",
                    sm: "row",
                    xs: "column",
                  }}
                  spacing={2}
                  justifyContent="space-between"
                  alignItems={{ xs: "center", sm: "flex-start" }}
                >
                  {/* Content Section */}
                  <Box
                    sx={{
                      maxWidth: {
                        xl: "100%",
                        lg: "100%",
                        md: "100%",
                        sm: "100%",
                        xs: "100%",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        // gap: 2,
                        // border: "2px solid red",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        height: "100%",
                        marginBottom: "4px",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          mb: 1,
                          fontSize: {
                            xs: "28px",
                            sm: "28px",
                            md: "28px",
                            lg: "28px",
                            xl: "28px",
                          },
                          // color: "rgb(5 78 146)"
                          // border: "2px solid blue",
                        }}
                      >
                        Interactive Reply Buttons
                      </Typography>
                    </Stack>

                    <Typography
                      variant="body1"
                      sx={{
                        // mb: 1,
                        fontSize: { xs: "14px", sm: "16px", md: "18px" },
                        color: "text.secondary",
                        lineHeight: 1.3,
                      }}
                    >
                      This Automobile Showcase template uses a video header to highlight vehicle features and combines a CTA button to instantly schedule a test drive or connect with a dealer, ensuring high engagement and fast customer conversion.
                    </Typography>

                    <Stack
                      direction="row"
                      spacing={1}
                      mb={4}
                      flexWrap="wrap"
                      sx={{ marginTop: "16px" }}
                    >
                      <Chip
                        label="#E-commerce"
                        variant="outlined"
                        sx={{
                          borderColor: "rgb(5, 78, 146)",
                          // backgroundColor: "rgb(5, 78, 146)",
                          color: "rgb(5, 78, 146)",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      />

                      <Chip
                        label="#Educational Institutions"
                        variant="outlined"
                        sx={{
                          borderColor: "rgb(5, 78, 146)",
                          // backgroundColor: "rgb(5, 78, 146)",
                          color: "rgb(5, 78, 146)",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      />

                      <Chip
                        label="#Healthcare"
                        variant="outlined"
                        sx={{
                          borderColor: "rgb(5, 78, 146)",
                          // backgroundColor: "rgb(5, 78, 146)",
                          color: "rgb(5, 78, 146)",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      />

                      <Chip
                        label="#Travel and Hospitality"
                        variant="outlined"
                        sx={{
                          borderColor: "rgb(5, 78, 146)",
                          color: "rgb(5, 78, 146)",
                          fontWeight: "500",
                          fontSize: "14px",
                        }}
                      />
                    </Stack>

                    <Stack>
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        mb={3}
                      >
                        <Button
                          variant="contained"
                          sx={{
                            backgroundColor: "rgb(5, 78, 146)",
                            borderColor: "rgb(5, 78, 146)",
                            color: "#FFF",
                            textTransform: "none",
                            padding: "10px 20px",
                            fontSize: { xs: "12px", sm: "14px", md: "16px" },
                            overflow: "hidden",
                            transition: "all 0.5s ease",
                            // minWidth: "200px",
                            ":hover": {
                              backgroundColor: "rgb(31, 133, 192)",
                              borderColor: "rgb(31, 133, 192)",
                            },
                            ":hover .text-slide": {
                              transform: "translateX(8px)",
                            },
                            ":hover .plus-slide": {
                              transform: "translateX(0)",
                              opacity: 1,
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              // position: "relative",
                              // minWidth: "100px",
                            }}
                          >
                            <Box
                              className="plus-slide"
                              sx={{
                                transform: "translateX(-20px)",
                                opacity: 0,
                                transition: "all 0.5s ease",
                                fontWeight: "bold",
                                fontSize: "18px",
                              }}
                            >
                              +
                            </Box>
                            <Box
                              className="text-slide"
                              sx={{
                                transition: "all 0.5s ease",
                              }}
                            >
                              Use this Template
                            </Box>
                          </Box>
                        </Button>

                        <Box sx={{ position: "relative" }}>
                          {/* Hover wrapper starts */}
                          <Box
                            onMouseEnter={() => setShowShareOptions(true)}
                            onMouseLeave={() => setShowShareOptions(false)}
                            sx={{ display: "inline-block", position: "relative" }}
                          >
                            {/* Share Icon */}
                            <img
                              src={shareIcon}
                              alt="Share"
                              style={{
                                width: "38px",
                                height: "38px",
                                cursor: "pointer",
                                padding: "4px",
                                boxSizing: "border-box",
                                filter:
                                  "invert(17%) sepia(99%) saturate(1000%) hue-rotate(183deg) brightness(90%) contrast(101%)",
                              }}
                            />

                            {/* Social Media Card */}
                            {showShareOptions && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  left: "50%",
                                  transform: "translateX(-50%)",
                                  zIndex: 10,
                                }}
                              >
                                <Paper
                                  elevation={3}
                                  sx={{
                                    position: "relative",
                                    mt: 0.5,
                                    px: 2,
                                    py: 2,
                                    width: "210px",
                                    minHeight: "110px",
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    textAlign: "center",
                                    boxShadow: "0px 3px 10px rgba(0,0,0,0.1)",
                                  }}
                                >
                                  {/* Triangle Pointer */}
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: "-10px",
                                      left: "50%",
                                      transform: "translateX(-50%) rotate(45deg)",
                                      width: "14px",
                                      height: "14px",
                                      backgroundColor: "#fff",
                                      boxShadow: "-1px -1px 1px rgba(0, 0, 0, 0.05)",
                                    }}
                                  />

                                  <Typography
                                    sx={{
                                      fontSize: "13px",
                                      fontWeight: 500,
                                      color: "#333",
                                      mb: 1.5,
                                    }}
                                  >
                                    Share this template on
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 1.2,
                                      justifyContent: "center",
                                    }}
                                  >
                                    {[facebookImg, linkedinImg, twitterImg, linkImg].map(
                                      (icon, idx) => (
                                        <img
                                          key={idx}
                                          src={icon}
                                          alt={`icon-${idx}`}
                                          style={{
                                            width: "32px",
                                            height: "32px",
                                            cursor: "pointer",
                                            borderRadius: "50%",
                                            transition: "transform 0.2s ease-in-out",
                                          }}
                                          onClick={() =>
                                            console.log(`Icon ${idx + 1} clicked`)
                                          }
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.transform = "scale(1.15)")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.transform = "scale(1)")
                                          }
                                        />
                                      )
                                    )}
                                  </Box>
                                </Paper>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Stack>
                    </Stack>

                    <Stack direction="column" spacing={2}>
                      <Stack
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: 2,
                          alignItems: "center",
                          justifyContent: "flex-start",
                          height: "100%",
                          marginBottom: "12px",
                        }}
                      >
                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: "bold",
                            fontSize: "28px",
                          }}
                        >
                          Have an Enquiry?
                        </Typography>
                      </Stack>

                      <Stack direction="row" sx={{ width: "100%" }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Enter your name"
                              fullWidth
                              InputProps={{
                                sx: {
                                  fontSize: { xs: "12px", sm: "14px" },
                                  backgroundColor: "#f5f8fd",
                                  borderRadius: "6px",
                                  paddingY: "8px",
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Enter your email ID"
                              fullWidth
                              InputProps={{
                                sx: {
                                  fontSize: { xs: "12px", sm: "14px" },
                                  backgroundColor: "#f5f8fd",
                                  borderRadius: "6px",
                                  paddingY: "8px",
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              variant="outlined"
                              size="small"
                              placeholder="Enter your message"
                              fullWidth
                              multiline
                              rows={3}
                              InputProps={{
                                sx: {
                                  fontSize: { xs: "12px", sm: "14px" },
                                  backgroundColor: "#f5f8fd",
                                  borderRadius: "6px",
                                  paddingY: "8px",
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Stack direction="row" justifyContent="flex-start">
                              <Button
                                variant="contained"
                                fullWidth
                                sx={{
                                  backgroundColor: "rgb(5, 78, 146)",
                                  color: "#FFF",
                                  textTransform: "none",
                                  fontSize: { xs: "12px", sm: "16px" },
                                  ":hover": {
                                    backgroundColor: "rgb(31, 133, 192)",
                                  },
                                  paddingY: "8px",
                                }}
                              >
                                Submit
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Stack>
                    </Stack>
                  </Box>
                </Stack>
              </Box>

              {/* Other template details */}
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.2,
                  marginTop: "30px",
                  // marginLeft: "12px",
                  // border: "2px solid red",
                }}
              >
                <Stack
                  sx={{
                    fontSize: {
                      xs: "28px",
                      sm: "28px",
                      md: "28px",
                      lg: "28px",
                      xl: "28px",
                    },
                    fontWeight: 600,
                    fontFamily: "'Roboto', sans-serif",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    // border: "1px solid red",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      // mb: 1,
                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      // border: "2px solid blue",
                    }}
                  >
                    What is an Interactive Reply Buttons Messages?
                  </Typography>
                </Stack>

                <Stack
                  sx={{
                    fontSize: { xs: "14px", sm: "16px", md: "18px" },
                    fontWeight: 400,
                    fontFamily: "'Roboto', sans-serif",
                    lineHeight: 1.3,
                    color: "text.secondary",
                  }}
                >
                  An Interactive Reply Buttons Message lets you present users with up to three predefined buttons they can tap to reply-making it easy and error-free for them to choose common options.
                </Stack>

                <Stack spacing={2} mt={1}>
                  {/* Heading */}
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      fontFamily: "'Roboto', sans-serif",
                    }}
                  >
                    Key Features
                  </Typography>

                  {/* Bullet Points with Vertical Line */}
                  <Stack direction="row" spacing={2}>
                    {/* Left: Vertical Line and Static Pulse Bullets */}
                    <Box
                      sx={{
                        position: "relative",
                        width: "24px",
                        minWidth: "24px",
                      }}
                    >
                      {/* Vertical Dashed Line */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 20,
                          height: "278px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          borderLeft: "2px dashed #d1d5db",
                        }}
                      />

                      {/* 1st bullet */}
                      <Box
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "rgba(5, 78, 146, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          top: "13px",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#054E91",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>

                      {/* 2nd bullet */}
                      <Box
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "rgba(5, 78, 146, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          top: "78px",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#054E91",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>

                      {/* 3rd bullet */}
                      <Box
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "rgba(5, 78, 146, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          top: "140px",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#054E91",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>

                      {/* 4th bullet */}
                      <Box
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "rgba(5, 78, 146, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          top: "228px",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#054E91",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>

                      {/* 5th bullet */}
                      <Box
                        sx={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "50%",
                          backgroundColor: "rgba(5, 78, 146, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "absolute",
                          top: "293px",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      >
                        <Box
                          sx={{
                            width: "10px",
                            height: "10px",
                            backgroundColor: "#054E91",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                    </Box>

                    {/* Your original content — Unchanged */}
                    <Stack
                      spacing={2}
                      sx={{
                        fontSize: { xs: "14px", sm: "16px", md: "18px" },
                        fontWeight: 400,
                        fontFamily: "'Roboto', sans-serif",
                        color: "text.secondary",
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "14px", sm: "16px", md: "18px", fontFamily: "'Open Sans', sans-serif"
                            },
                          }}
                        >
                          <strong style={{ fontFamily: "'Open Sans', sans-serif" }}> Up to 3 Buttons: </strong>
                        </Typography>
                        <Typography
                          pl={2}
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontFamily: "'Open Sans', sans-serif",
                            lineHeight: 1.3,
                            fontWeight: 400,
                            fontSize: "16px",
                          }}
                        >
                          Offer at most three quick-reply options beneath your
                          message.
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "14px", sm: "16px", md: "18px",
                              fontFamily: "'Open Sans', sans-serif",
                            },
                          }}
                        >
                          <strong style={{ fontFamily: "'Open Sans', sans-serif" }}>Single-Tap Responses: </strong>
                        </Typography>
                        <Typography
                          pl={2}
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontFamily: "'Open Sans', sans-serif",
                            lineHeight: 1.3,
                            fontWeight: 400,
                            fontSize: "16px",
                          }}
                        >
                          Each button sends back a unique ID so your backend can
                          route logic immediately.
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "14px", sm: "16px", md: "18px",
                              fontFamily: "'Open Sans', sans-serif",
                            },
                          }}
                        >
                          <strong style={{ fontFamily: "'Open Sans', sans-serif" }}>24-Hour & Template Modes:</strong>
                        </Typography>

                        <Stack pl={2} spacing={0.5}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "8px",
                            }}
                          >
                            <Box
                              sx={{
                                mt: "6px",
                                width: "6px",
                                height: "6px",
                                bgcolor: "text.secondary",
                                borderRadius: "50%",
                                flexShrink: 0,
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                fontFamily: "'Open Sans', sans-serif",
                                lineHeight: 1.3,
                                fontWeight: 400,
                                fontSize: "16px",
                                ml: 2
                              }}
                            >
                              <span style={{ fontWeight: "600", fontFamily: "'Open Sans', sans-serif" }}>
                                Free-form:
                              </span>{" "}
                              Send within the 24-hour customer-service window
                              without approval.
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "8px",
                            }}
                          >
                            <Box
                              sx={{
                                mt: "6px",
                                width: "6px",
                                height: "6px",
                                bgcolor: "text.secondary",
                                borderRadius: "50%",
                                flexShrink: 0,
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                color: "text.secondary",
                                fontFamily: "'Open Sans', sans-serif",
                                lineHeight: 1.3,
                                fontWeight: 400,
                                fontSize: "16px",
                                ml: 2
                              }}
                            >
                              <span style={{ fontWeight: "600", fontFamily: "'Open Sans', sans-serif" }}>
                                Template-based:
                              </span>{" "}
                              Use a pre-approved template to send buttons
                              outside that window.
                            </Typography>
                          </Box>
                        </Stack>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "14px", sm: "16px", md: "18px",
                              fontFamily: "'Open Sans', sans-serif",
                            },
                          }}
                        >
                          <strong style={{ fontFamily: "'Open Sans', sans-serif" }}>Reusable in any Interactive Flow: </strong>
                        </Typography>
                        <Typography
                          pl={2}
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontFamily: "'Open Sans', sans-serif",
                            lineHeight: 1.3,
                            fontWeight: 400,
                            fontSize: "16px",
                          }}
                        >
                          Perfect for language selection, menu navigation,
                          confirmations, and more.
                        </Typography>
                      </Box>

                      <Box>
                        <Typography
                          sx={{
                            fontSize: {
                              xs: "14px", sm: "16px", md: "18px",
                              fontFamily: "'Open Sans', sans-serif",
                            },
                          }}
                        >
                          <strong style={{ fontFamily: "'Open Sans', sans-serif" }}>Mutually Exclusive: </strong>
                        </Typography>
                        <Typography
                          pl={2}
                          variant="body2"
                          sx={{
                            color: "text.secondary",
                            fontFamily: "'Open Sans', sans-serif",
                            lineHeight: 1.3,
                            fontWeight: 400,
                            fontSize: "16px",
                          }}
                        >
                          You cannot mix reply buttons with List Messages or CTA
                          URL Buttons in the same payload.
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </Stack>

                <Stack
                  sx={{
                    fontSize: {
                      xs: "24px",
                      sm: "28px",
                      md: "28px",
                      lg: "28px",
                      xl: "28px",
                    },
                    fontWeight: 600,
                    fontFamily: "'Roboto', sans-serif",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    mt: 1
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                    }}
                  >
                    Common Use Cases
                  </Typography>
                </Stack>

                <Grid container spacing={2} alignItems="stretch" mt={0.5}>
                  {[
                    {
                      title: "🌐 Language Selection",
                      desc: "We would love to assist you better.<br/> Please select your preferred language to continue:",
                      buttons: ["English", "हिन्दी"],
                    },
                    {
                      title: "📊 Quick Surveys",
                      desc: `We would love your feedback!<br/> How satisfied are you with our service today?`,
                      buttons: ["Great", " Okay", "Poor"],
                    },
                    {
                      title: "📦 Order Confirmation",
                      desc: "Your recent order was dispatched successfully!<br/> Did you receive your package?",
                      buttons: ["Yes", "No"],
                    },
                    {
                      title: "📅 Appointment Actions",
                      desc: "Need to make changes to your appointment? What would you like to do next?",
                      buttons: ["Reschedule", "Contact Support"],
                    },

                  ].map((item, idx) => (
                    <Grid item xs={12} sm={6} key={idx}>
                      <Stack
                        spacing={0.5}
                        sx={{
                          height: "100%",
                          fontFamily: "'Roboto', sans-serif",
                          border: "1px solid #e0e0e0",
                          padding: 2.5,
                          borderRadius: 3,
                          backgroundColor: "#f5f8fd",
                          justifyContent: "flex-start",
                          transition: "0.3s",
                          ":hover": {
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: { xs: "14px", sm: "16px", md: "18px" },
                            color: "text.secondary",
                          }}
                        >
                          {item.title}
                        </Typography>

                        <Typography
                          sx={{
                            pl: 2.3,
                            color: "text.secondary",
                            fontFamily: "'Roboto', sans-serif",
                            lineHeight: 1.3,
                            fontWeight: 400,
                            fontSize: "16px",
                          }}
                          dangerouslySetInnerHTML={{ __html: item.desc }}
                        />

                        {/* Visual CTA buttons */}
                        <Stack direction="row" spacing={1} flexWrap="wrap" mt={2} pl={2}>


                          {item.buttons.map((btn, i) => (
                            <Box
                              key={i}
                              sx={{
                                backgroundColor: "#ffffff",
                                color: "#0077cc",
                                border: "1px solid #c2e0ff",
                                fontSize: "14px",
                                borderRadius: "20px",
                                px: 2,
                                py: 0.6,
                                cursor: "pointer",
                                fontWeight: 570,
                                boxShadow: "1px 1px 3px rgba(0,0,0,0.05)",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                transition: "all 0.3s ease",
                                ":hover": {
                                  backgroundColor: "#0077cc",
                                  color: "#ffffff",
                                  svg: {
                                    color: "#ffffff",
                                  },
                                },
                              }}
                            >
                              {/* Show IoCallOutline only for Contact Support, else BsReply */}
                              {btn.trim() === "Contact Support" ? (
                                <IoCallOutline style={{ fontSize: 16 }} />
                              ) : (
                                <BsReply style={{ fontSize: 16 }} />
                              )}
                              {btn}
                            </Box>
                          ))}

                        </Stack>

                      </Stack>
                    </Grid>
                  ))}
                </Grid>

              </Stack>
            </Box>

            {/* Sticky right side box */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "400px",
                position: "sticky",
                top: 20,
                zIndex: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                mx: "auto",
              }}
            >
              {/* Toggle Button Group */}
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "320px",
                }}
              >
                <ToggleButtonGroup
                  exclusive
                  value={platform}
                  onChange={(e, value) => {
                    if (!value || value === platform) return;

                    // Set animation direction based on toggle
                    if (value === "ios") {
                      setDirection("right");
                      setPlatform("ios");
                    } else {
                      setDirection("left");
                      setPlatform("android");
                    }

                    setHasAnimatedOnce(true); // Now start allowing animation
                  }}
                  sx={{
                    borderRadius: "12px",
                    justifyContent: "center",
                    ml: 5
                  }}
                >
                  <ToggleButton
                    value="android"
                    sx={{
                      textTransform: "none",
                      fontWeight: imageStatus ? "bold" : "normal",
                      color: imageStatus ? "#000" : "#444",
                      backgroundColor: imageStatus ? "#fff" : "transparent",
                      borderRadius: "12px",
                      px: 2,
                      py: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      transition: "all 0.5s ease",
                      "&:hover": { backgroundColor: "#e4e4e4" },
                    }}
                  >
                    <Box
                      component="img"
                      src={AndroidIcon}
                      alt="Android"
                      sx={{ width: 23, height: 23 }}
                    />
                    Android
                  </ToggleButton>

                  <ToggleButton
                    value="ios"
                    sx={{
                      textTransform: "none",
                      fontWeight: !imageStatus ? "bold" : "normal",
                      color: !imageStatus ? "#000" : "#444",
                      backgroundColor: !imageStatus ? "#fff" : "transparent",
                      borderRadius: "12px",
                      px: 2,
                      py: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      transition: "all 0.5s ease",
                      "&:hover": { backgroundColor: "#e4e4e4" },
                    }}
                  >
                    <Box
                      component="img"
                      src={appleIcon}
                      alt="iOS"
                      sx={{ width: 22, height: 22 }}
                    />
                    iOS
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>

              {/* Frame with inner screen */}
              <Box sx={{ borderRadius: 3, overflow: "hidden" }}>
                <Box
                  key={platform}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px",
                    position: "relative",
                    width: "100%",
                    maxWidth: "320px",
                    mx: "auto",
                    animation: `${direction === "right"
                      ? "smoothSlideRight"
                      : "smoothSlideLeft"} 1s ease-in-out`,
                  }}
                >
                  {platform === "android" ? (
                    // Android Frame
                    <Box
                      sx={{
                        position: "relative",
                        width: "270px",
                        height: "620px",
                        border: "3px solid #333",
                        borderRadius: "23px",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                      }}
                    >
                      {/* Notch */}
                      <Box
                        sx={{
                          width: "62px",
                          height: "6px",
                          borderRadius: "10px",
                          backgroundColor: "#333",
                          position: "absolute",
                          top: "6px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          zIndex: 2,
                        }}
                      />

                      {/* Scrollable Screen */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: "20px",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          overflowY: "scroll",
                          scrollbarWidth: "thin",
                          "&::-webkit-scrollbar": {
                            width: "6px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#666",
                            borderRadius: "4px",
                          },
                          "&::-webkit-scrollbar-track": {
                            backgroundColor: "#f1f1f1",
                          },
                        }}
                      >
                        <Box sx={{ height: "1500px" }} />
                      </Box>
                    </Box>
                  ) : (
                    // iOS Frame
                    <Box
                      sx={{
                        position: "relative",
                        width: "270px",
                        height: "620px",
                        border: "3px solid #333",
                        borderRadius: "30px",
                        backgroundColor: "#fff",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        overflow: "hidden",
                      }}
                    >
                      {/* Pill Notch */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: "6px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: "78px",
                          height: "20px",
                          backgroundColor: "#1f1f1f",
                          borderRadius: "12px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          px: "6px",
                          zIndex: 2,
                        }}
                      >
                        <Box
                          sx={{
                            width: "4px",
                            height: "4px",
                            borderRadius: "50%",
                            backgroundColor: "#c38b5f",
                          }}
                        />
                        <Box
                          sx={{
                            width: "12px",
                            height: "12px",
                            borderRadius: "50%",
                            backgroundColor: "#000",
                            border: "1px solid #2a2a2a",
                          }}
                        />
                      </Box>

                      {/* Scrollable Screen */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: "32px",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          overflowY: "scroll",
                          scrollbarWidth: "thin",
                          "&::-webkit-scrollbar": {
                            width: "6px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#666",
                            borderRadius: "4px",
                          },
                          "&::-webkit-scrollbar-track": {
                            backgroundColor: "#f1f1f1",
                          },
                        }}
                      >
                        <Box sx={{ height: "1500px" }} />
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>

              {/* Previous / Next Buttons below frame */}
              <Stack
                direction="row"
                spacing={5}
                sx={{ mt: -1, justifyContent: "center" }}
              >
                {/* Previous Button */}
                <IconButton
                  onClick={() => {
                    setSelectedArrow("prev");
                    navigate("/template7");
                  }}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    border: "1.4px solid #d4d4d4",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#e4e4e4",
                    },
                    color: "#444",
                  }}
                >
                  <MdChevronLeft size={22} />
                </IconButton>

                {/* Next Button */}
                <IconButton
                  onClick={() => {
                    setSelectedArrow("next");
                    navigate("/template9");
                  }}
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    backgroundColor: "#ffffff",
                    border: "1.4px solid #d4d4d4",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#e4e4e4",
                    },
                    color: "#444",
                  }}
                >
                  <MdChevronRight size={22} />
                </IconButton>
              </Stack>
            </Box>
          </Stack>

          {/* Description */}
          <Stack
            sx={{
              height: "auto",
              // border: "2px solid green",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
            }}
          >

            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: {
                  xl: "column",
                  lg: "column",
                  sm: "column",
                  xs: "column",
                },
                width: "100%",
                justifyContent: "space-between",
                height: "auto",
              }}
            >
              <Stack
                sx={{
                  lineHeight: {
                    lg: "32px",
                    xl: "32px",
                    md: "32px",
                    xs: "16px",
                    sm: "32px",
                  },
                  fontSize: {
                    lg: "28px",
                    xl: "28px",
                    md: "28px",
                    xs: "12px",
                    sm: "28px",
                  },
                  fontFamily: "'Roboto', sans-serif",
                  fontWeight: "700",
                  color: "rgb(0, 0, 0)",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    mb: 2,
                    fontSize: {
                      xs: "28px",
                      sm: "28px",
                      md: "28px",
                      lg: "28px",
                      xl: "28px",
                    },
                    // border: "2px solid blue",
                  }}
                >
                  Component Support Table
                </Typography>
              </Stack>
              <Stack
                direction="row"
                sx={{
                  width: "100%",
                  alignItems: "flex-start",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    width: "66%",
                    // maxHeight: "100vh",
                    height: "auto",
                    overflowY: "auto",
                    // border: "1px solid green",
                    // padding: 2,
                    marginTop: "20px",
                  }}
                >
                  <WhatsAppComponentTable2 />
                </Box>

                <Box
                  sx={{
                    width: "34%",
                    position: "sticky",
                    // top: 20, // distance from top when scrolling
                    // border: "1px solid red",
                    marginTop: "20px",
                    // height: "fit-content",
                    height: "auto",
                  }}
                >
                  <Box sx={{ width: "100%", height: "100%" }}>
                    <img
                      // src={`http://localhost:5000/images/${
                      //   card?.image4 || card?.image
                      // }`}
                      src={DescriptionImg}
                      alt="img"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              height: "auto",
              // border: "2px solid green",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: {
                  xl: "column",
                  lg: "column",
                  sm: "column",
                  xs: "column",
                },
                width: { xl: "100%", lg: "100%", sm: "100%", xs: "100%" },
                justifyContent: "space-between",
                //   alignItems: "center",
                // height: { xl: "94vh", lg: "94vh", sm: "94vh" },
                height: "auto",
              }}
            >
              <Stack sx={{ width: "100%" }}>
                <Stack
                  sx={{
                    lineHeight: {
                      lg: "32px",
                      xl: "40px",
                      md: "32px",
                      xs: "23px",
                      sm: "36px",
                    },
                    // marginTop: {
                    //   lg: "40px",
                    //   xl: "40px",
                    //   md: "40px",
                    //   xs: "40px",
                    //   sm: "40px",
                    // },
                    // fontSize: "39px",
                    fontSize: {
                      lg: "29px",
                      xl: "36px",
                      md: "24px",
                      xs: "18px",
                      sm: "28px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: "700",
                    color: "rgb(0, 0, 0)",
                    // paddingLeft: {
                    //   lg: "8px",
                    //   xl: "8px",
                    //   md: "8px",
                    //   xs: "0px",
                    //   sm: "8px",
                    // },
                    marginBottom: "20px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      // border: "2px solid blue",
                    }}
                  >
                    Example Request
                  </Typography>
                </Stack>

                <Stack
                  sx={{
                    // border: "3px solid blue",
                    // marginLeft: {
                    //   lg: "8px",
                    //   xl: "8px",
                    //   md: "8px",
                    //   xs: "0px",
                    //   sm: "8px",
                    // },
                    backgroundColor: "#1c1e21",
                    height: "auto", // ✅ Limit height to prevent overflow
                    overflowX: "auto", // ✅ Allow horizontal scroll
                    overflowY: "auto", // ✅ Allow vertical scroll if multiline
                    boxSizing: "border-box",
                    width: "100%",
                    whiteSpace: "pre", // ✅ Preserve formatting (instead of nowrap)
                    // border: "2px solid red",
                  }}
                >
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      backgroundColor: "#282c34",
                      whiteSpace: "pre",
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<VscJson color="white" size={24} />}
                      sx={{
                        marginTop: "12px",
                        marginLeft: "12px",
                        minWidth: "unset",
                        color: "white",
                        backgroundColor: "transparent",
                        border: "transparent",
                        boxShadow: "none", // remove elevation
                        "&:hover": {
                          backgroundColor: "transparent", // 👈 No hover background
                          border: "transparent", // 👈 No hover border
                          boxShadow: "none", // 👈 No hover shadow
                        },
                      }}
                    >
                      json
                    </Button>{" "}
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCopy}
                      //  startIcon={ <MdOutlineContentCopy color="white" size={24} />}
                      startIcon={
                        copied ? (
                          <MdCheckCircleOutline color="white" size={24} />
                        ) : (
                          <MdOutlineContentCopy color="white" size={24} />
                        )
                      }
                      sx={{
                        marginTop: "12px",
                        marginRight: "12px",
                        minWidth: "unset",
                        color: "white",
                        backgroundColor: "transparent",
                        border: "transparent",
                        boxShadow: "none", // remove elevation
                        "&:hover": {
                          backgroundColor: "transparent", // 👈 No hover background
                          border: "transparent", // 👈 No hover border
                          boxShadow: "none", // 👈 No hover shadow
                        },
                      }}
                    >
                      {copied ? "copied" : "copy"}
                    </Button>
                  </Stack>

                  <SyntaxHighlighter
                    language="json"
                    style={oneDark}
                    wrapLines
                    customStyle={{
                      overflowX: "auto",
                      margin: 0,
                      //   minWidth: "fit-content", // ✅ shrink to content width
                    }}
                  >
                    {codeString}
                  </SyntaxHighlighter>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              height: "auto",
              // border: "2px solid green",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: {
                  xl: "column",
                  lg: "column",
                  sm: "column",
                  xs: "column",
                },
                width: { xl: "100%", lg: "100%", sm: "100%", xs: "100%" },
                justifyContent: "space-between",
                //   alignItems: "center",
                // height: { xl: "94vh", lg: "94vh", sm: "94vh" },
                height: "auto",
              }}
            >
              <Stack sx={{ width: "100%" }}>
                <Stack
                  sx={{
                    lineHeight: {
                      lg: "32px",
                      xl: "40px",
                      md: "32px",
                      xs: "23px",
                      sm: "36px",
                    },
                    // marginTop: {
                    //   lg: "40px",
                    //   xl: "40px",
                    //   md: "40px",
                    //   xs: "40px",
                    //   sm: "40px",
                    // },
                    // fontSize: "39px",
                    fontSize: {
                      lg: "29px",
                      xl: "36px",
                      md: "24px",
                      xs: "18px",
                      sm: "28px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: "700",
                    color: "rgb(0, 0, 0)",
                    // paddingLeft: {
                    //   lg: "8px",
                    //   xl: "8px",
                    //   md: "8px",
                    //   xs: "0px",
                    //   sm: "8px",
                    // },

                    marginBottom: {
                      lg: "20px",
                      xl: "20px",
                      md: "20px",
                      xs: "0px",
                      sm: "20px",
                    },

                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      // border: "2px solid blue",
                    }}
                  >
                    Example Response
                  </Typography>
                </Stack>

                <Stack
                  sx={{
                    // border: "3px solid blue",
                    // marginLeft: {
                    //   lg: "8px",
                    //   xl: "8px",
                    //   md: "8px",
                    //   xs: "0px",
                    //   sm: "8px",
                    // },
                    backgroundColor: "#1c1e21",
                    height: "auto", // ✅ Limit height to prevent overflow
                    overflowX: "auto", // ✅ Allow horizontal scroll
                    overflowY: "auto", // ✅ Allow vertical scroll if multiline
                    boxSizing: "border-box",
                    width: "100%",
                    whiteSpace: "pre", // ✅ Preserve formatting (instead of nowrap)
                  }}
                >
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      backgroundColor: "#282c34",
                      whiteSpace: "pre",
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<VscJson color="white" size={24} />}
                      sx={{
                        marginTop: "12px",
                        marginLeft: "12px",
                        minWidth: "unset",
                        backgroundColor: "transparent",
                        color: "white",
                        border: "transparent",
                        boxShadow: "none", // remove elevation
                        "&:hover": {
                          backgroundColor: "transparent", // 👈 No hover background
                          border: "transparent", // 👈 No hover border
                          boxShadow: "none", // 👈 No hover shadow
                        },
                      }}
                    >
                      json
                    </Button>{" "}
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCopy3}
                      startIcon={
                        copied ? (
                          <MdCheckCircleOutline color="white" size={24} />
                        ) : (
                          <MdOutlineContentCopy color="white" size={24} />
                        )
                      }
                      sx={{
                        marginTop: "12px",
                        marginRight: "12px",
                        minWidth: "unset",
                        backgroundColor: "transparent",
                        color: "white",
                        border: "transparent",
                        boxShadow: "none", // remove elevation
                        "&:hover": {
                          backgroundColor: "transparent", // 👈 No hover background
                          border: "transparent", // 👈 No hover border
                          boxShadow: "none", // 👈 No hover shadow
                        },
                      }}
                    >
                      {copied ? "copied" : "copy"}
                    </Button>
                  </Stack>
                  <SyntaxHighlighter
                    language="json"
                    style={oneDark}
                    wrapLines
                    customStyle={{
                      overflowX: "auto",
                      margin: 0,
                      //   minWidth: "fit-content", // ✅ shrink to content width
                    }}
                  >
                    {codeString3}
                  </SyntaxHighlighter>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            sx={{
              height: "auto",
              // border: "2px solid green",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: {
                  xl: "column",
                  lg: "column",
                  sm: "column",
                  xs: "column",
                },
                width: {
                  xl: "100%",
                  lg: "100%",
                  md: "100%",
                  sm: "100%",
                  xs: "100%",
                },
                justifyContent: "space-between",
                //   alignItems: "center",
                // height: { xl: "94vh", lg: "94vh", sm: "94vh" },
                height: "auto",
              }}
            >
              <Stack sx={{ width: "100%" }}>
                <Stack
                  sx={{
                    lineHeight: {
                      lg: "32px",
                      xl: "40px",
                      md: "32px",
                      xs: "23px",
                      sm: "36px",
                    },
                    // marginTop: {
                    //   lg: "40px",
                    //   xl: "40px",
                    //   md: "40px",
                    //   xs: "40px",
                    //   sm: "40px",
                    // },
                    // fontSize: "39px",
                    fontSize: {
                      lg: "29px",
                      xl: "36px",
                      md: "24px",
                      xs: "18px",
                      sm: "28px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: "700",
                    color: "rgb(0, 0, 0)",
                    // paddingLeft: {
                    //   lg: "8px",
                    //   xl: "8px",
                    //   md: "8px",
                    //   xs: "0px",
                    //   sm: "8px",
                    // },
                    marginBottom: {
                      lg: "20px",
                      xl: "20px",
                      md: "20px",
                      xs: "0px",
                      sm: "20px",
                    },
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      mb: 2,
                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      // border: "2px solid blue",
                    }}
                  >
                    Example Webhook
                  </Typography>
                </Stack>

                <Stack
                  sx={{
                    // border: "3px solid blue",
                    // marginLeft: {
                    //   lg: "8px",
                    //   xl: "8px",
                    //   md: "8px",
                    //   xs: "0px",
                    //   sm: "8px",
                    // },
                    backgroundColor: "#1c1e21",
                    height: "auto", // ✅ Limit height to prevent overflow
                    overflowX: "auto", // ✅ Allow horizontal scroll
                    overflowY: "auto", // ✅ Allow vertical scroll if multiline
                    boxSizing: "border-box",
                    width: "100%",
                    whiteSpace: "pre", // ✅ Preserve formatting (instead of nowrap)
                  }}
                >
                  <Stack
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      backgroundColor: "#282c34",
                      whiteSpace: "pre",
                    }}
                  >
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<VscJson color="white" size={24} />}
                      sx={{
                        marginTop: "12px",
                        marginLeft: "12px",
                        minWidth: "unset",
                        backgroundColor: "transparent",
                        color: "white",
                        border: "transparent",
                        boxShadow: "none", // remove elevation
                        "&:hover": {
                          backgroundColor: "transparent", // 👈 No hover background
                          border: "transparent", // 👈 No hover border
                          boxShadow: "none", // 👈 No hover shadow
                        },
                      }}
                    >
                      json
                    </Button>{" "}
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleCopy4}
                      startIcon={
                        copied ? (
                          <MdCheckCircleOutline color="white" size={24} />
                        ) : (
                          <MdOutlineContentCopy color="white" size={24} />
                        )
                      }
                      sx={{
                        marginTop: "12px",
                        marginRight: "12px",
                        minWidth: "unset",
                        backgroundColor: "transparent",
                        color: "white",
                        border: "transparent",
                        boxShadow: "none", // remove elevation
                        "&:hover": {
                          backgroundColor: "transparent", // 👈 No hover background
                          border: "transparent", // 👈 No hover border
                          boxShadow: "none", // 👈 No hover shadow
                        },
                      }}
                    >
                      {copied ? "copied" : "copy"}
                    </Button>
                  </Stack>
                  <SyntaxHighlighter
                    language="json"
                    style={oneDark}
                    wrapLines
                    customStyle={{
                      overflowX: "auto",
                      margin: 0,
                      //   minWidth: "fit-content", // ✅ shrink to content width
                    }}
                  >
                    {codeString4}
                  </SyntaxHighlighter>
                </Stack>
              </Stack>
            </Stack>
          </Stack>

          {/* curl details table */}
          <Stack
            sx={{
              height: "auto",
              // border: "2px solid green",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "40px",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: {
                  xl: "column",
                  lg: "column",
                  sm: "column",
                  xs: "column",
                },
                width: {
                  xl: "100%",
                  lg: "100%",
                  md: "100%",
                  sm: "100%",
                  xs: "100%",
                },
                justifyContent: "space-between",
                //   alignItems: "center",
                // height: { xl: "94vh", lg: "94vh", sm: "94vh" },
                height: "auto",
              }}
            >
              <Stack
                sx={{
                  lineHeight: {
                    lg: "32px",
                    xl: "32px",
                    md: "32px",
                    xs: "16px",
                    sm: "32px",
                  },
                  // marginTop: {
                  //   lg: "40px",
                  //   xl: "40px",
                  //   md: "40px",
                  //   xs: "40px",
                  //   sm: "40px",
                  // },
                  // fontSize: "39px",
                  fontSize: {
                    lg: "28px",
                    xl: "28px",
                    md: "28px",
                    xs: "12px",
                    sm: "28px",
                  },
                  fontFamily: "'Roboto', sans-serif",
                  fontWeight: "700",
                  color: "rgb(0, 0, 0)",
                  // paddingLeft: {
                  //   lg: "8px",
                  //   xl: "8px",
                  //   md: "8px",
                  //   xs: "0px",
                  //   sm: "8px",
                  // },

                  marginBottom: "20px",
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    // border: "2px solid red",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    height: "100%", // ✅ Fixed height
                    // marginBottom: "12px",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",

                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      // border: "2px solid blue",
                    }}
                  >
                    Curl Details
                  </Typography>
                </Stack>
              </Stack>{" "}
              <SecondTable />
            </Stack>
          </Stack>

          {/* body details table */}
          <Stack
            sx={{
              // height: "98vh",
              height: "auto",
              // border: "2px solid blue",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Stack
              sx={{
                // border: "1px solid red",
                display: "flex",
                flexDirection: {
                  xl: "column",
                  lg: "column",
                  sm: "column",
                  xs: "column",
                },
                width: { xl: "100%", lg: "100%", sm: "100%", xs: "100%" },
                justifyContent: "space-between",
                //   alignItems: "center",
                // height: { xl: "94vh", lg: "94vh", sm: "94vh" },
                marginTop: "40px",
                height: "100%",
              }}
            >
              <Stack
                sx={{
                  lineHeight: {
                    lg: "32px",
                    xl: "40px",
                    md: "32px",
                    xs: "23px",
                    sm: "36px",
                  },
                  fontSize: {
                    lg: "29px",
                    xl: "36px",
                    md: "24px",
                    xs: "18px",
                    sm: "28px",
                  },
                  fontFamily: "'Roboto', sans-serif",
                  fontWeight: "700",
                  color: "rgb(0, 0, 0)",
                  marginBottom: {
                    lg: "28px",
                    xl: "28px",
                    md: "28px",
                    xs: "20px",
                    sm: "28px",
                  },
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    // border: "2px solid red",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    height: "100%",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",

                      fontSize: {
                        xs: "28px",
                        sm: "28px",
                        md: "28px",
                        lg: "28px",
                        xl: "28px",
                      },
                      // border: "2px solid blue",
                    }}
                  >
                    Post Body Parameters
                  </Typography>
                </Stack>
              </Stack>

              <TableContainer
                component={Paper}
                elevation={2}
                sx={{
                  borderRadius: "12px",
                  overflow: "hidden",
                }}
              >
                <Table>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#f3f4f6", borderBottom: "1px solid #ccc" }}>
                      {["Placeholder", "Description", "Example Value"].map((header) => (
                        <TableCell key={header} sx={{ fontWeight: 600, fontSize: "18px", borderRight: "1px solid #d0d0d0" }}>
                          <b>{header}</b>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Row 1 */}
                    <TableRow>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2 }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px", lineHeight: 1.4 }}>
                          &lt;CUSTOMER_PHONE_NUMBER&gt;
                        </Typography>
                        <Typography sx={{ color: "green", fontSize: "15.5px", mt: 1, lineHeight: 1.4 }}>
                          &lt;TO&gt;
                        </Typography>
                        <Typography sx={{ fontStyle: "italic", fontSize: "15.5px", mt: 1 }}>String</Typography>
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2 }}>
                        <Typography sx={{ color: "green", fontWeight: 600, fontSize: "15.5px", fontStyle: "italic" }}>Required</Typography>
                        <Typography sx={{ mt: 1, fontSize: "15.5px" }}>
                          The WhatsApp ID or phone number of the customer the message is being sent to.
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px" }}>" +919876543211 "</Typography>
                      </TableCell>
                    </TableRow>

                    {/* Row 2 */}
                    <TableRow>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2, backgroundColor: "#fafafa" }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px" }}>&lt;TYPE&gt;</Typography>
                        <Typography sx={{ fontStyle: "italic", fontSize: "15.5px", mt: 1 }}>String</Typography>
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2, backgroundColor: "#fafafa" }}>
                        <Typography sx={{ color: "green", fontWeight: 600, fontSize: "15.5px", fontStyle: "italic" }}>Required</Typography>
                        <Typography sx={{ mt: 1, fontSize: "15.5px" }}>
                          Must be "interactive" for all interactive messages.
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2, backgroundColor: "#fafafa" }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px" }}>" interactive "</Typography>
                      </TableCell>
                    </TableRow>

                    {/* Row 3 */}
                    <TableRow>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2 }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px", lineHeight: 1.4 }}>
                          &lt;HEADER.MEDIA_URL&gt;
                        </Typography>
                        <Typography sx={{ fontStyle: "italic", fontSize: "15.5px", mt: 1 }}>String</Typography>
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2 }}>
                        <Typography sx={{ color: "#D32F2F", fontWeight: 600, fontSize: "15.5px", fontStyle: "italic" }}>Optional</Typography>
                        <Typography sx={{ mt: 1, fontSize: "15.5px", lineHeight: 1.6 }}>
                          (only if header.type = "media").<br />
                          <Box component="span" sx={{ display: "inline-block", mt: 1 }}>
                            HTTPS URL to your promo video.
                          </Box>
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2 }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px" }}>" https://example.com/media/car_demo.mp4 "</Typography>
                      </TableCell>
                    </TableRow>

                    {/* Row 4 */}
                    <TableRow>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", pt: 1.5, pb: 2, px: 2, backgroundColor: "#fafafa" }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px", mb: 1 }}>&lt;BODY_TEXT&gt;</Typography>
                        <Typography sx={{ fontStyle: "italic", fontSize: "15.5px" }}>String</Typography>
                      </TableCell>
                      <TableCell sx={{ borderRight: "1px solid #d0d0d0", p: 2, backgroundColor: "#fafafa" }}>
                        <Typography sx={{ color: "green", fontWeight: 600, fontSize: "15.5px", fontStyle: "italic" }}>Required</Typography>
                        <Typography sx={{ mt: 1, fontSize: "15.5px", lineHeight: 1.6 }}>
                          Main message copy shown above the buttons.
                          <br />
                          <Box component="span" sx={{ display: "inline-block", mt: 1 }}>
                            <li>Max: 1,024 chars</li>
                            <li>Emojis supported</li>
                          </Box>
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ p: 2, backgroundColor: "#fafafa" }}>
                        <Typography sx={{ color: "green", fontSize: "15.5px" }}>
                          " Hi, \n🚗 Experience innovation, style and performance like never before! Watch this exclusive video
                          showcasing the features.\n\n Interested in seeing it in person? \n Tap below to schedule a test drive or
                          get connected with our sales expert instantly. "
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Template8;







